import React, { createContext, useContext, useState } from 'react';
import { ThemeProvider, createMuiTheme, ThemeOptions } from '@material-ui/core/styles';

export interface ThemeProps extends ThemeOptions {
  set: (id: string) => boolean
}

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const themeBaseDefaultDark = createMuiTheme({
  palette: {
    primary: {
      "100": '#000',
      "200": '#31333E',
      "300": '#2B2D37',
      "400": '#1F2024',
      "500": '#9e9e9e',
      "600": '#8e8e8e',
      "700": '#B5B5B5',
      "800": '#eeeeee',
      "900": '#E5E5E5',
      main: '#67FFC8',
    },
    background: {
      default: '#2c2e38',
      paper: '#373a44'
    },
    text: {
      primary: '#67FFC8',
      secondary: '#67FFC8',
    }
  }
});

const themeBaseDefault = createMuiTheme({
  palette: {
    // type: "light",
    primary: {
      "100": '#000',
      "200": '#31333E',
      "300": '#2B2D37',
      "400": '#1F2024',
      "500": '#9e9e9e',
      "600": '#8e8e8e',
      "700": '#B5B5B5',
      "800": '#eeeeee',
      "900": '#E5E5E5',
      main: '#1976d2',
    },
    background: {
      default: '#F4F5F7',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#32178B',
      secondary: '#32178B',
    }
  }
});

const themeDefault: ThemeProps = {
  ...themeBaseDefault,
  set: () => false
}

export const ThemeContext = createContext<ThemeProps>(themeDefault);

const themes: { id: string, theme: ThemeOptions }[] = [
  {
    id: 'neon',
    theme: themeBaseDefault
  }
]

export const ThemeContextProvider = ({ children }: any) => {
  const [theme, setTheme] = useState<ThemeOptions>(themeBaseDefault);

  const set = (id: string) => {
    const newTheme = themes.find(t => t.id === id);
    if (!newTheme)
      return false;

    setTheme(newTheme.theme);
    return true;
  }

  return (
    <ThemeContext.Provider value={{ ...theme, set }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);